import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=02655aae&scoped=true&"
import script from "./coupon.vue?vue&type=script&lang=js&"
export * from "./coupon.vue?vue&type=script&lang=js&"
import style0 from "./coupon.vue?vue&type=style&index=0&id=02655aae&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02655aae",
  null
  
)

export default component.exports